import React from 'react';
import Skeleton from '../Skeleton';
import Suspense from '../Suspense';
import useInitialRender from '../../hooks/useInitialRender';
import useToggle from '../../hooks/useToggle';
import NoStore from './NoStore';
import StockStatusPanel from './StockStatusPanel';
import useUserStore from './useUserStore';
import StockStatusCard from './StockStatusCard';

const LeadTime = React.lazy(() => import('./LeadTime'));

interface IItemStockStatus {
  distributionType: 'Drop Shipment' | undefined;
  moderArtikelId?: string;
  configurationId?: string;
  m3Id: string;
  variantId: string;
}

const ItemStockStatus = ({
  distributionType,
  moderArtikelId,
  configurationId,
  m3Id,
  variantId,
}: IItemStockStatus) => {
  const useLeadTime = distributionType === 'Drop Shipment';
  const { updateUserStore, userStore, loading: loadingStores } = useUserStore();
  const [showAll, toggleShowAll] = useToggle(false);
  const isInitialRender = useInitialRender(true);

  const stockRequest: IItemStockRequest = {
    configurationId,
    moderArtikelId,
    m3Id,
    variantId,
    quantity: 1,
  };

  if (useLeadTime) {
    return (
      <Suspense fallback={<Skeleton height="120px" />}>
        <LeadTime stockRequest={stockRequest} />
      </Suspense>
    );
  }

  if (isInitialRender() || loadingStores) {
    return (
      <>
        <Skeleton height="120px" />
      </>
    );
  }

  return (
    <>
      {showAll && (
        <StockStatusPanel
          onClose={toggleShowAll}
          onSelectStore={updateUserStore}
          selectedStoreId={userStore?.storeId}
          stockRequest={stockRequest}
        />
      )}
      {!userStore && <NoStore onClick={toggleShowAll} />}
      {userStore && (
        <StockStatusCard
          stockRequest={stockRequest}
          toggleShowAll={toggleShowAll}
          userStore={userStore}
        />
      )}
    </>
  );
};

export default ItemStockStatus;
